import { Loading } from '../../components/InvitePage/Loading';

export const LoadingPage = () => {
  return (
    <div>
      <Loading />
    </div>
  );
};
